import React, { useState, useEffect } from 'react';
import { CardActionable } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
/* eslint-disable  import/no-cycle -- need */
import { constructChildStructure } from '../ChildConstructor';

/**
 * Card Selection component return custom component
 * @param {*} param
 */
const ActionableCard = ({
  fieldId,
  childElements,
  props,
}) => {
  const { formSubmissionPayload, setFormSubmissionPayload } = props;
  const [selectedOption, setSelectedOption] = useState(
    childElements.length > 0 ? childElements[0].value : ''
  );
  useEffect(() => {
    formSubmissionPayload[fieldId] = selectedOption;
    setFormSubmissionPayload({
      ...formSubmissionPayload,
      elemId: null,
    });
  }, [selectedOption]);

  const handleCardSelection = (value) => {
    setSelectedOption(value);
  };
  /* eslint-enable  import/no-cycle -- need */
  return (
    <div className="row pad-responsive" id={fieldId}>
      {childElements?.map((childElement) => (
        <CardActionable
          type="button"
          key={childElement.cardId}
          onClick={() => handleCardSelection(childElement.value)}
          className="col-lg-6 col-xs-6 margin-responsive-b "
          style={{ border: selectedOption === childElement.value && '2px solid #006fcf' }}
        >
          {constructChildStructure([childElement], props, fieldId)}
        </CardActionable>
      ))}

    </div>
  );
};

ActionableCard.propTypes = {
  fieldId: PropTypes.string,
  childElements: PropTypes.objectOf(PropTypes.shape),
  props: PropTypes.objectOf(PropTypes.shape),
  setFormSubmissionPayload: PropTypes.func,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
};

export default ActionableCard;
